import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
}
export function SEO({
  title = 'Senator Fatimat Raji Rasaki Foundation',
  description = 'The SFRR Foundation is dedicated to uplifting the underprivileged across Nigeria through education, healthcare, and economic opportunities. Transforming lives from vulnerability to dignity and self-reliance.',
  keywords = 'SFRR Foundation, Senator Fatimat Raji Rasaki, Nigerian nonprofit, education support, healthcare access, women empowerment, youth development, community development, humanitarian work Nigeria',
  image = 'https://cdn.magicpatterns.com/uploads/bbEknxtjSFBKULaAfMFH6V/674f1612-c4d6-4931-84d9-dd37fd86f516.jpg',
  url = 'https://sfrrfoundation.org',
  type = 'website',
  author = 'SFRR Foundation',
  publishedTime,
  modifiedTime
}: SEOProps) {
  const fullTitle = title.includes('SFRR') ? title : `${title} | SFRR Foundation`;
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : url;
  return <Helmet data-id="element-343">
      {/* Primary Meta Tags */}
      <title data-id="element-344">{fullTitle}</title>
      <meta name="title" content={fullTitle} data-id="element-345" />
      <meta name="description" content={description} data-id="element-346" />
      <meta name="keywords" content={keywords} data-id="element-347" />
      <meta name="author" content={author} data-id="element-348" />

      {/* Canonical URL */}
      <link rel="canonical" href={siteUrl + (typeof window !== 'undefined' ? window.location.pathname : '')} data-id="element-349" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} data-id="element-350" />
      <meta property="og:url" content={siteUrl} data-id="element-351" />
      <meta property="og:title" content={fullTitle} data-id="element-352" />
      <meta property="og:description" content={description} data-id="element-353" />
      <meta property="og:image" content={image} data-id="element-354" />
      <meta property="og:image:width" content="1200" data-id="element-355" />
      <meta property="og:image:height" content="630" data-id="element-356" />
      <meta property="og:site_name" content="SFRR Foundation" data-id="element-357" />
      <meta property="og:locale" content="en_NG" data-id="element-358" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-359" />
      <meta name="twitter:url" content={siteUrl} data-id="element-360" />
      <meta name="twitter:title" content={fullTitle} data-id="element-361" />
      <meta name="twitter:description" content={description} data-id="element-362" />
      <meta name="twitter:image" content={image} data-id="element-363" />
      <meta name="twitter:creator" content="@SFRRFoundation" data-id="element-364" />

      {/* Article specific */}
      {type === 'article' && publishedTime && <meta property="article:published_time" content={publishedTime} data-id="element-365" />}
      {type === 'article' && modifiedTime && <meta property="article:modified_time" content={modifiedTime} data-id="element-366" />}

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" data-id="element-367" />
      <meta name="language" content="English" data-id="element-368" />
      <meta name="revisit-after" content="7 days" data-id="element-369" />
      <meta name="theme-color" content="#0F766E" data-id="element-370" />

      {/* Geo Tags */}
      <meta name="geo.region" content="NG" data-id="element-371" />
      <meta name="geo.placename" content="Abuja, Nigeria" data-id="element-372" />

      {/* Mobile Optimization */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" data-id="element-373" />
      <meta name="format-detection" content="telephone=yes" data-id="element-374" />
      <meta name="apple-mobile-web-app-capable" content="yes" data-id="element-375" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" data-id="element-376" />

      {/* Structured Data - Organization */}
      <script type="application/ld+json" data-id="element-377">
        {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'NGO',
        name: 'Senator Fatimat Raji Rasaki Foundation',
        alternateName: 'SFRR Foundation',
        url: siteUrl,
        logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aXeXdP1aRi4Xt5RFum28MJ/Untitled_design.png',
        description: description,
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Suite 48A, Shakir Plaza, Garki',
          addressLocality: 'Abuja',
          addressCountry: 'NG'
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+234-803-330-4041',
          contactType: 'Customer Service',
          email: 'info@sfrrfoundation.org',
          areaServed: 'NG',
          availableLanguage: ['en']
        },
        founder: {
          '@type': 'Person',
          name: 'Senator Fatimat Raji Rasaki'
        },
        foundingDate: '2024',
        sameAs: ['https://facebook.com/sfrrfoundation', 'https://twitter.com/sfrrfoundation', 'https://instagram.com/sfrrfoundation', 'https://linkedin.com/company/sfrrfoundation']
      })}
      </script>
    </Helmet>;
}